import { RootState } from 'types/state';
import { STATUS_SUBMITTED } from 'constants/enums/applicationStatuses';
import { extractDate } from 'components/Section/History/dateranges';

// eslint-disable-next-line
const getState = (state: RootState) => state.application;
export const getFormType = (state: RootState) => state.application.Settings.formType;
export const getFormVersion = (state: RootState) => state.application.Settings.formVersion;
export const getIsLocked = (state: RootState) => state.application.Settings.status === STATUS_SUBMITTED;

export const getMaritalStatus = (state: RootState) => state.application.Relationships.Marital?.Status?.value;

export const getRelativesList = (state: RootState) => state.application.Relationships.Relatives?.List.items;

export const getApplicantSSN = (state: RootState) => state.application.Identification.ApplicantSSN?.ssn;

export const getMaritalSSN = (state: RootState) => state.application.Relationships.Marital?.CivilUnion?.SSN;

export const getCohabitantsList = (state: RootState) => state.application.Relationships.Cohabitants?.CohabitantList?.items;

export const getApplicantName = (state: RootState) => state.application.Identification.ApplicantName;
export const getApplicantBirthdate = (state: RootState) => state.application.Identification.ApplicantBirthDate?.Date;
export const getApplicantBirthdateAsDate = (state: RootState) => extractDate(getApplicantBirthdate(state) ?? {});
export const getApplicantSex = (state: RootState) => state.application.Identification.Physical?.Sex;

// TODO: Need to fix to support non-defined state scenarios
export const getOtherNames = (state: RootState) => {
  const otherNames = state.application.Identification?.OtherNames;

  const names = otherNames?.List?.items
    .filter((i: any) => i.Item && i.Item.Name)
    .map((i: any) => i.Item.Name);

  return names;
};

export const getAddressBooks = ({ application }: RootState) => {
  const { Relatives, People } = application.Relationships;
  const {
    Residence, Education, Employment, Federal
  } = application.History;
  const { Support, Contacts } = application.Foreign;
  const { Bankruptcy } = application.Financial;
  const { OrderedTreatments, VoluntaryTreatments } = application.Substance;
  const { Consultations, Hospitalizations } = application.Psychological;
  const {
    Unlawful,
    Manipulating,
    MembershipOverthrow,
    MembershipViolence,
    TerroristOrganization,
    Unauthorized,
    NonCompliance, 
  } = application.Legal;

  const getAddressItemsOf = (section: any, addressFieldName = 'Address') => (section?.List?.items ?? [])
    .filter((item: any) => item.Item?.[addressFieldName]?.validated)
    .map((item: any) => item.Item?.[addressFieldName]);

  return {
    Residence: getAddressItemsOf(Residence),
    Reference: getAddressItemsOf(People),
    Relative: getAddressItemsOf(Relatives),
    Education: getAddressItemsOf(Education),
    Employment: getAddressItemsOf(Employment),
    ForeignNational: getAddressItemsOf(Support),
    Court: getAddressItemsOf(Bankruptcy, 'CourtAddress'),
    Provider: [
      ...getAddressItemsOf(OrderedTreatments, 'TreatmentProviderAddress'),
      ...getAddressItemsOf(VoluntaryTreatments, 'TreatmentProviderAddress'),
    ],
    Organization: getAddressItemsOf(TerroristOrganization),
    Facility: [
      ...getAddressItemsOf(Hospitalizations, 'FacilityAddress'),
      ...getAddressItemsOf(Consultations, 'CourtAddress'),
    ],
    Incident: [
      ...getAddressItemsOf(Unlawful, 'Location'),
      ...getAddressItemsOf(Unauthorized, 'Location'),
      ...getAddressItemsOf(NonCompliance, 'Location'),
      ...getAddressItemsOf(Manipulating, 'Location'),
      ...getAddressItemsOf(MembershipViolence),
      ...getAddressItemsOf(MembershipOverthrow),
    ],
    Agency: getAddressItemsOf(Federal),
    Company: getAddressItemsOf(Contacts),
  };
};

export const getPeopleWhoKnowYouWell = ({ application }: RootState) => application?.Relationships?.People?.List?.items;

export const getMilitaryHistoryHasServed = (state: RootState) => state.application.Military.History?.HasServed?.value === 'Yes';
